export default __webpack_public_path__ + "static/media/Mohammad Shihabuddin - Corporate Relations Associate.c7f83035.jpg";